import React from "react";
import { Route, Redirect } from "react-router-dom";

const ProtectedRoute = ({ component: Component, authUser, ...rest }) => (
  <Route
    {...rest}
    render={(props) =>
      authUser ? <Component {...props} /> : <Redirect to="/" />
    }
  />
);

export default ProtectedRoute;
